import simpleJobResponse from 'assets/responses/simpleJobResponse';

export const setSampleJob = () => {
  const date = new Date();
  const now = date.toISOString();
  const runStart = new Date(date.setSeconds(date.getSeconds() + 1)).toISOString();
  const runEnd = new Date(date.setSeconds(date.getSeconds() + 2)).toISOString();
  const jobBody = {
    ...simpleJobResponse.data,
    createdOn: now,
    runStart,
    runEnd,
  };
  localStorage.setItem('sampleJob', JSON.stringify(jobBody));
};

export const getSampleJob = () => {
  const job = JSON.parse(localStorage.getItem('sampleJob'));
  return job && {
    ...job,
    hasStatevector: true, // this is for the jobs saved in localstorage before this field was added
  };
};
